import { Pipe } from '@angular/core';
import { isNumberFinite } from '../utils/utils';
var RandomPipe = (function () {
    function RandomPipe() {
    }
    RandomPipe.prototype.transform = function (input, min, max) {
        if (min === void 0) { min = 0; }
        if (max === void 0) { max = 1; }
        if (!isNumberFinite(min) || !isNumberFinite(max)) {
            return input;
        }
        if (min > max) {
            max = min;
            min = 0;
        }
        return Math.random() * (max - min) + min;
    };
    return RandomPipe;
}());
export { RandomPipe };
RandomPipe.decorators = [
    { type: Pipe, args: [{
                name: 'random'
            },] },
];
/** @nocollapse */
RandomPipe.ctorParameters = function () { return []; };
//# sourceMappingURL=random.pipe.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular-pipes/esm/math/random.pipe.js
// module id = 266
// module chunks = 103